<template>
    <div class="row panel-body">
        <form method="post" ref="form" :action="postRoute">
            <input type="hidden" name="_token" :value="csrfToken"/>

            <quiz-localization-question
                    v-for="(question, idx) in questions"
                    v-on:forceUpdate="forceUpdate()"
                    ref="questions"
                    :idx="idx"
                    :key="question.qid"
                    :qid="question.qid"
                    :type="question.type"
                    :level="question.level"
                    :suggestedAnswerOid="question.suggestedAnswerOid"
                    :XX_en="question.text.XX_en"
                    :ilocalization="question.text[locale]"
                    :ioptions="question.options"
                    :locale="locale"
                    :country-name="countryName"
                    :pictureUrl="question.pictureUrl"
                    :correctionComment="correctionComments[question.qid] ?? ''"
            ></quiz-localization-question>

            <div class="row">
                <div class="col-xs-6">
                    <button class="btn btn-default"
                            name="submit-save"
                            @click.prevent="save('Saved')">
                        <strong>Save</strong>
                    </button>
                </div>

                <div class="col-xs-6 text-right">
                    <submit-button :disabled="!allDataIsValid" title="Submit"></submit-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    let toastr = require('toastr');

    export default {
        props: {
            'questionsJson': String,
            'saveRoute': String,
            'postRoute': String,
            'locale': String,
            'countryName': String,
            'correctionCommentsJson': String,
        },

        data: function() {
            return {
                questions: [],
                csrfToken: window.csrfToken,
                updateTrigger: false,
                correctionComments: JSON.parse(this.correctionCommentsJson),
                autosaveCache: '',
            };
        },

        computed: {
            allDataIsValid: function() {
                if (this.updateTrigger) {
                    for (let index in this.$refs.questions) {
                        if (!this.$refs.questions[index].validate()) {
                            return false;
                        }
                    }
                    return true;
                }
            },
        },

        mounted() {
            let questions = JSON.parse(this.questionsJson);
            let tmpQuestionsArray = [];
            for (let idx in questions) {
              if(!('suggestedAnswerOid' in questions[idx])) {
                    questions[idx].suggestedAnswerOid = null;
                }
                tmpQuestionsArray.push(questions[idx]);
            }
            // don't push to this.questions inside of the loop, because it triggers re-rendering in every iteration.
            this.questions = tmpQuestionsArray;

            this.updateTrigger = true;
            this.forceUpdate();

            this.autosaveCache = $(this.$refs.form).serialize();
            this.autosaveTimer();
        },

        methods: {
            forceUpdate: function() {
                this.updateTrigger = false;
                this.$forceUpdate();
                this.updateTrigger = true;
            },

            autosaveTimer() {
                setTimeout(() => {
                    this.autosave();
                    this.autosaveTimer();
                }, 60000); // once per minute
            },

            autosave() {
                // only autosave if form data has changed since last save
                if (this.autosaveCache !== $(this.$refs.form).serialize()) {
                    this.save('Auto saved');
                }
            },

            save(message) {
                let formData = $(this.$refs.form).serialize();

                window.axios.post(this.saveRoute, formData).then(() => {
                    this.autosaveCache = formData;
                    toastr.success(message);
                }).catch(() => {
                    toastr.error('Something went wrong...', message);
                });
            },
        },
    };
</script>
